<template>
  <warning-modal
    class="inform-modal"
    name="inaccessible-serum-inform-modal"
    :title="$t('dashboard.modal.unavailableDMAE.title')"
    large-screen-width="460"
    @before-open="onBeforeOpen"
  >
    <template #main-content>
      <p>
        {{ $t('dashboard.modal.unavailableDMAE.description') }}
      </p>
      <p>
        {{ $t('dashboard.modal.unavailableDMAE.info') }}
      </p>
    </template>

    <template #actions>
      <button
        class="rounded-button-white"
        :class="{ 'rounded-button-white__alma': isAlmaTerritory }"
        @click="handleClose(true)"
      >
        {{ $t('dashboard.modal.unavailableDMAE.button') }}
      </button>
    </template>
  </warning-modal>
</template>

<script>
import WarningModal from '@/modules/dashboard/components/common/warning-modal/WarningModal.vue';
import isAlmaTerritories from '@/modules/dashboard/components/mixins/isAlmaTerritories';

export default {
  name: 'InaccessibleSerumInformModal',
  components: { WarningModal },
  mixins: [isAlmaTerritories],
  data() {
    return { onClose: null };
  },
  methods: {
    onBeforeOpen({ params: { onClose } }) {
      this.onClose = onClose;
    },
    handleClose(confirm) {
      this.onClose({ confirm });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/common/buttons.scss';
</style>
